// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerLoader_loader__hcQwI","rotation":"SpinnerLoader_rotation__sBxIf","center":"SpinnerLoader_center__lru+3"};